import i18n, { localeFor } from '../i18n';

function moneyLocale() {
  return localeFor(i18n.language);
}

export function currencySymbol(code = 'ILS') {
  try {
    const parts = new Intl.NumberFormat(moneyLocale(), {
      style: 'currency',
      currency: code,
      currencyDisplay: 'narrowSymbol',
    }).formatToParts(0);
    return parts.find((p) => p.type === 'currency')?.value || code;
  } catch {
    return code;
  }
}

// Matches backend/utils/currency.js's currencyName(). Unlike currencySymbol and
// formatMoney above, this one IS user-facing prose ("New Shekel", "Russian Ruble"),
// so it follows the UI language. The picker's list normally arrives already
// named from the API; this covers the local seed and any offline fallback.
export function currencyName(code = 'ILS', lng = 'he') {
  try {
    return new Intl.DisplayNames([lng], { type: 'currency' }).of(code) || code;
  } catch {
    return code;
  }
}

export function formatMoney(amount, code = 'ILS') {
  const n = Number(amount);
  if (!Number.isFinite(n)) return formatMoney(0, code);
  try {
    return new Intl.NumberFormat(moneyLocale(), {
      style: 'currency',
      currency: code || 'ILS',
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return `${n.toLocaleString(moneyLocale(), { maximumFractionDigits: 2 })} ${currencySymbol(code)}`;
  }
}

/**
 * Dual display for multi-currency expenses.
 * Primary = what was paid (original); secondary = group base.
 */
export function expenseMoneyParts(expense, baseCurrency = 'ILS') {
  const base = baseCurrency || 'ILS';
  const hasOriginal = expense?.originalCurrency
    && expense.originalAmount != null
    && expense.originalCurrency !== base;

  if (hasOriginal) {
    return {
      primary: formatMoney(expense.originalAmount, expense.originalCurrency),
      secondary: formatMoney(expense.amount, base),
    };
  }
  return {
    primary: formatMoney(expense?.amount, base),
    secondary: null,
  };
}
